module.exports = __webpack_public_path__ + "img/screeningempty.99857f1b.svg";